import { Component, EventEmitter, Input, Output } from "@angular/core";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { PopupDialogConfig } from "../popup.model";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ButtonDirective } from "@components";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-popup-page",
  templateUrl: "./popup-page.component.html",
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, ButtonDirective, TranslateModule],
  styleUrls: ["./popup-page.component.scss"],
})
export class PopupPageComponent {
  @Output() pageNext = new EventEmitter<void>();
  @Output() pageBack = new EventEmitter<void>();

  @Input() config!: PopupDialogConfig;
  @Input() popupHeight = "90%";
  @Input() popupWidth = "90%";

  faXmark = faXmark;

  @Output() closePopup = new EventEmitter<void>();

  handleClose(): void {
    this.closePopup.emit();
  }

  clickBackgroundClose(): void {
    if (this.config.closeOnBackgroundClick) {
      this.handleClose();
    }
  }

  next() {
    this.pageNext.emit();
  }

  back() {
    this.pageBack.emit();
  }

  stopPropagation(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
